/*
 * File: ConditionalWrapper.jsx
 * Project: mtp-webui
 * File Created: Monday, 3rd May 2021 10:38:20 am
 * Author: Tarek Sanger (tarek@nuenergy.ai)
 * -----
 * Last Modified: Saturday, 18th September 2021 11:15:33 am
 * Modified By: Tarek Sanger (tarek@nuenergy.ai)
 * -----
 * Copyright 2017 - 2021 NuEnergy.ai, NuEnergy.ai
 */
import React from 'react';

interface IConditionalWrapProps {
  condition: boolean;
  wrapper: (c: React.ReactElement) => JSX.Element;
  children: React.ReactElement;
}

const ConditionalWrapper = ({ condition, wrapper, children }: IConditionalWrapProps): JSX.Element => (condition ? wrapper(children) : <>{children}</>);

export default ConditionalWrapper;
